module.exports = __webpack_public_path__ + "images/emoji/fu.cac361a2a3da22d4bea4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fu.png
// module id = AnJp
// module chunks = 14